var _circle, _circle2, _circle3, _circle4, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderStatusDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 77 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.2939,
    cy: 38,
    r: 38,
    fill: "white",
    fillOpacity: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.2939,
    cy: 38,
    r: 37.75,
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.2939,
    cy: 38,
    r: 38,
    fill: "white",
    fillOpacity: 0.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.2939,
    cy: 38,
    r: 37.75,
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.8219 22.446L38.1536 34.1115L26.4881 22.446L22.5996 26.3345L34.2651 38L22.5996 49.6655L26.4881 53.554L38.1536 41.8885L49.8219 53.554L53.7104 49.6655L42.0449 38L53.7104 26.3345L49.8219 22.446Z",
    fill: "#474747",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderStatusDelete);
export default __webpack_public_path__ + "static/media/orderStatusDelete.89f34a02840079edb58ebf30454d446c.svg";
export { ForwardRef as ReactComponent };